<template>
  <div>
    <template v-if="isConfirmed">
      <h5>Confirmed faults</h5>
      <p>You selected the below faults on {{ confirmedDate }}.</p>
      <ul class="list-group selection-list my-3">
        <li class="list-group-item mb-0" v-for="problem in confirmedProblemTitles" :key="problem.id">
          {{ problem.title }}
        </li>
      </ul>
    </template>

    <template v-else>
      <h5>Select device faults</h5>
      <p class="text-sm mt-1 mb-4">
        Before we can attend your repair we need to know what the faults are with your device.
        Please select from the below options.
      </p>

      <h5>Frequently selected</h5>
      <ul class="list-group selection-list mt-3 mb-4">
        <li :class="{'pre-selected': bookedProblems.includes(problem.id)}" class="list-group-item mb-0" v-for="problem in highlightedProblems" :key="problem.id">
          <div class="custom-control custom-checkbox d-flex">
            <input
                type="checkbox"
                :id="`problem-${problem.id}`"
                :value="problem.id"
                class="custom-control-input"
                v-model="confirmedProblems"
                :disabled="bookedProblems.includes(problem.id)"
            >
            <label :for="`problem-${problem.id}`" class="custom-control-label mb-0 flex-grow-1">
              {{ problem.title }}
            </label>
          </div>
        </li>
      </ul>

      <ul class="list-group selection-list my-3">
        <li :class="{'pre-selected': bookedProblems.includes(problem.id)}" class="list-group-item mb-0" v-for="problem in problems" :key="problem.id">
          <div class="custom-control custom-checkbox d-flex">
            <input
                type="checkbox"
                :id="`problem-${problem.id}`"
                :value="problem.id"
                class="custom-control-input"
                v-model="confirmedProblems"
                :disabled="bookedProblems.includes(problem.id)"
            >
            <label :for="`problem-${problem.id}`" class="custom-control-label mb-0 flex-grow-1">
              {{ problem.title }}
            </label>
          </div>
        </li>
      </ul>
      <div v-if="cantConfirm" class="alert alert-danger">
        You need to select one or more device fault to be able to confirm.
      </div>
      <button class="btn btn-success w-100" :disabled="cantConfirm" @click="actionConfirm">Confirm Device Faults</button>
    </template>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    orderRef: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      required: true
    },
    // When set to true the interface will prefill the booked problems and disable the checkbox from
    // user editing. Ollie asked that we make it so that the customer has to select all, while
    // retaining the additive nature of the form handling on the backend.
    useBookedProblems: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bookedProblems: [],
      confirmedProblems: [],
      persisting: false,
      confirmedAt: null,
    }
  },
  computed: {
    highlightedProblems() {
      return this.device.problems
        .filter(problem => problem.highlighted || problem.selected)
        .sort((a, b) => a.title.localeCompare(b.title));
    },

    problems() {
      return this.device.problems
        .filter(problem => !problem.highlighted && ! problem.selected)
        .sort((a, b) => a.title.localeCompare(b.title));
    },

    confirmedProblemTitles() {
      return this.device.problems.filter(problem => this.confirmedProblems.includes(problem.id))
    },
    isConfirmed() {
      return this.confirmedAt !== null;
    },
    confirmedDate() {
      return this.confirmedAt
          ? moment(this.confirmedAt).format('ddd Do MMM')
          : null;
    },
    cantConfirm() {
      return this.confirmedProblems.length === 0
    }
  },
  created() {
    const problems = this.device.problems
        .filter(problem => problem.selected)
        .reduce((carry, problem) => {
          return [...carry, problem.id];
        }, []);

    this.confirmedAt = this.device.problems_confirmed_at;

    if (this.useBookedProblems || this.isConfirmed) {
      this.confirmedProblems = problems;
      this.bookedProblems = problems;
    }

  },
  methods: {
    actionConfirm() {
      if (this.cantConfirm) {
        return;
      }
      this.persisting = true;
      this.$http.patch(
          `api/v4/customer/${this.orderRef}/devices/${this.device.id}/confirm`,
          {
            problems: this.confirmedProblems
          }
      ).then((r) => {
        this.confirmedAt = r.data.data.problems_confirmed_at;
        this.persisting = false;
      }).catch((e) => {
        console.error(e);
        this.persisting = false;
      })
    }
  }
}

</script>

<style>
.pre-selected {
  background: #fbe8cd;
}
</style>